
export const COOKIE_BARION_CONSENT = 'barion_consent_1732278795 ';
export const COOKIE_COOKIES_ACCEPTED = 'cookies_accepted_1732278795 ';
export const COOKIE_COOKIES_DECLINED_RECENTLY = 'cookies_declined_recently_1732278795 ';
export const COOKIE_UTM_PARAMETERS = 'utm_params_1704446142';